const PRODUCTION_API_URL = 'https://clarity-platform-api.ryan-dc4.workers.dev';

export function getApiUrl(): string {
  return (import.meta as any).env?.VITE_WORKER_API_URL ?? PRODUCTION_API_URL;
}
